import { Injectable } from '@angular/core';
import { UserRole } from 'app/core/authentication';
import { REGISTER_ROUTE } from 'app/register/register-routing.constant';

@Injectable({
  providedIn: 'root'
})
export class RegisterService {
  public getRegisterRoute(role: UserRole.student | UserRole.parent | UserRole.teacher | undefined): String[] {
    if (!role) {
      return REGISTER_ROUTE.route();
    }
    switch(role) {
      case UserRole.student:
        return REGISTER_ROUTE.STUDENT.route();
      case UserRole.parent:
        // SCHOOL-2245 - since parent is hidden for now take them to generic one
        return REGISTER_ROUTE.route();
      default:
        return REGISTER_ROUTE.TEACHER.route();
    }
  }
}